import { all as allCountries } from 'country-codes-list';

export type Country = {
  code: string;
  name: string;
  dialCode: string;
  flag: string;
};

export const COUNTRIES: readonly Country[] = allCountries()
  .filter((c) => c.countryCode && c.countryCallingCode && c.countryNameEn)
  .map((c) => ({
    code: c.countryCode,
    name: c.countryNameEn,
    dialCode: c.countryCallingCode,
    flag: c.flag,
  }))
  .sort((a, b) => a.name.localeCompare(b.name));

export const COUNTRY_BY_CODE: Readonly<Record<string, Country>> = Object.fromEntries(COUNTRIES.map((c) => [c.code, c]));
